import { render } from "./ComponentTL.vue?vue&type=template&id=223a3b56"
import script from "./ComponentTL.vue?vue&type=script&lang=js"
export * from "./ComponentTL.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__